import { useParams } from "react-router-dom";
import ReasonCode from '../ReasonCode/Draft'
import WorkCenter from '../WorkCenter/Draft'
import EditBatchNo from '../EditBatchNo'
import RecordPicklist from '../RecordPicklist'
import RetainRecord from '../RetainRecord'
import ExtraCompoent from '../ExtraComponent'
import { useState, useEffect, useContext, useCallback, useRef, useMemo } from "react";
import { DataStore, SortDirection } from '@aws-amplify/datastore'
import ProductionOrderHeader from '../../ProductionOrderHeader'
import { DgtPdOrderReasonCode } from '../../../models'
import { Documents, OrderType, MainMenu } from '../../../constants/Enum'
import OrderContext from '../../../contexts/OrderContext'
import SyncExpressionContext from '../../../contexts/SyncExpressionContext'
import UserContext from '../../../contexts/UserContext'
import RecordTimeTypeContext from '../../../contexts/RecordTimeTypeContext'
import MovementContext from '../../../contexts/MovementContext'
import OrderReceiptContext from "../../../contexts/OrderReceiptContext";
import { syncQueriesReady, removeSync } from '../../../sync/DataStoreSync'
import SpinnerLoading from "../../../components/SpinnerLoading"
import { convertJson } from '../../../utilities/Validate'
import TabMenu from "../../../components/TabMenu"
import { 
	getRemotePicklistById,
	postComment,
	getMovementsById,
	getOrderReceipts,
	updateStatusComment
} from '../../../states/PicklistAction'
import Comment from '../../../components/Comment'
import {
	getOrder
} from '../../../apis/order'
import PicklistContext from "../../../contexts/PicklistContext";
import { getDataStoreOperations } from "../../../apis";

const ProductionProcessComponent = () => {
	const { id } = useParams()

	const { order, setOrder } = useContext(OrderContext)
	const { setSyncOrderID } = useContext(SyncExpressionContext)
	const { user, readOnly } = useContext(UserContext)

	const [currentMenu, setCurrentMenu] = useState('edit_batch_no')
	const [operations, setOperations] = useState([])
	const [reasonCodes, setReasonCodes] = useState([])
	const [ movements, setMovements ] = useState([])
	const [ picklistHeader, setPicklistHeader ] = useState()
	const [ picklistItems, setPicklistItems ] = useState([])
	const [ picklistComments, setPicklistComments ] = useState([])
	const [ orderReceipts, setOrderReceipts ] = useState([])

	const [currentTimeType, setCurrentTimeType] = useState('');
  const valueCurrentTimeType = { currentTimeType, setCurrentTimeType };

	const unSubIotFunc = useRef(null)

	const username = user?.name || user?.givenName || user?.username || ''

	const mutateHeader = (updatedHeader) => {
		setPicklistHeader(updatedHeader)
	}

	const mutateMovements = (updatedMovements) => {
		setMovements(movements.map(mv => {
			const found = updatedMovements.find(updated => updated.sk === mv.sk)
			return found || mv
		}))
	}

	const mutateOrderReceipt = (updatedOrderReceipt) => {
		setOrderReceipts(orderReceipts.map(log => 
      log.productionOrderId === updatedOrderReceipt.productionOrderId &&
			log.batchLotNo === updatedOrderReceipt.batchLotNo
			? updatedOrderReceipt : log))
	}

	const mutateOrderReceipts = (updatedOrderReceipts) => {
		setOrderReceipts(updatedOrderReceipts)
	}

	const onTabSelected = (key) => {
		setCurrentMenu(key)
	}

	const fetchPdProcess = async () => {
		try {
			const operations = await getDataStoreOperations(id)
			setOperations(operations)

			const reasonCodes = await DataStore.query(DgtPdOrderReasonCode,
				rc => rc.productionOrderId('eq', id), { sort: rc => rc.materialCode(SortDirection.ASCENDING) })
			setReasonCodes(reasonCodes)
		} catch (error) {
			console.log("Error retrieving ProductionOrders", error);
		}
	}

	
	const onUpdateBatchNoCompleted = useCallback((updatedOrder) => {
		if (updatedOrder) setOrder(updatedOrder)

		setCurrentMenu('operation')
	}, [ setOrder ])

	const onSkipUpdateBatchNo = useCallback(() => {
		setCurrentMenu('operation')
	}, [])

	const pleaseRefresh = () => {
		fetchPdProcess()
	}

	useEffect(() => {
		const listener1 = syncQueriesReady(fetchPdProcess, null)
		return () => {
			removeSync(listener1)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	useEffect(() => {
		setSyncOrderID(id)

		const fetchOrder = async (orderId) => {
			try {
				const order = await getOrder(orderId)
				setOrder(order)
			} catch (error) {
				console.log("Error retrieving ProductionOrder", error);
			}
		}
		
		const fetchPicklistItems = async (orderId) => {
			const picklists = await getRemotePicklistById(orderId)
			const { header, items, comments } = picklists
			setPicklistHeader(header)
			setPicklistItems(items)
			setPicklistComments(comments)
		}
		const fetchMovements = async (orderId) => {
			const mvs = await getMovementsById(orderId)
      setMovements(mvs.filter(itm => itm.movementType !== '262'))
		}

		const fetchOrderReceipts = async (orderId) => {
			const orderReceipts =  await getOrderReceipts(orderId)
			setOrderReceipts(orderReceipts)
		}

		fetchOrder(id)

		fetchPicklistItems(id)

		fetchMovements(id)

		fetchOrderReceipts(id)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])
	
	const onPostComment = useCallback(async (comment: string) => {
    const commentResponse = await postComment(id, comment, username)
		setPicklistComments([...picklistComments, commentResponse])
  }, [ id, username, picklistComments ])

	const onActiveComment = useCallback(async (orderId: string, skCommentId: string, active: boolean, version: number) => {
		const updatedComment = await updateStatusComment(orderId, skCommentId, active, version)
		setPicklistComments(picklistComments.map(comment => comment.sk === skCommentId ? updatedComment : comment))
	}, [ picklistComments, setPicklistComments ])

	useEffect(() => {
		const unSubFunc = unSubIotFunc
		// Noted : unsub IOT when exit page
		return () => unSubFunc && unSubFunc.current()
	}, [])

	const renderBody = () => {
		if (operations.length === 0) return <SpinnerLoading />

		if (currentMenu === 'operation') {
			return <RecordTimeTypeContext.Provider value={valueCurrentTimeType}>
				<WorkCenter workCenters={operations} order={order} setOrder={setOrder} unSubFunc={unSubIotFunc} />
			</RecordTimeTypeContext.Provider>
		} else if (currentMenu === 'reason_code') {
			return <ReasonCode reasonCodes={reasonCodes} pleaseRefresh={pleaseRefresh}/>
		} else if (currentMenu === 'edit_batch_no') {
			let batchNumbers = []
			if (order) {
				if (order.actualBatchNumbers) {
					const originalBatch = order.batchNumbers ? convertJson(order.batchNumbers) : []
					const mergedBatch = [...convertJson(order.actualBatchNumbers), ...originalBatch]
					mergedBatch.forEach(batch => {
						const sixLastDigit = batch.slice(-6)
						if (!batchNumbers.map(b => b.slice(-6)).includes(sixLastDigit)) {
							batchNumbers.push(batch)
						}
					})
				} else if (order.batchNumbers) {
					batchNumbers = convertJson(order.batchNumbers)
				}
			}
			return <EditBatchNo
				batchNumbers={batchNumbers}
				onUpdateCompleted={onUpdateBatchNoCompleted}
				onSkiped={onSkipUpdateBatchNo}
				isEmptyLot={order && order.batchNumbers === '[]'}
			/>
		} else if (currentMenu === 'picklist') {
			return <RecordPicklist header={picklistHeader}
				materialItems={picklistItems.filter(item => (item.withdrawQty || 0) >= 0 || item.materialType === 'BULK' || item.materialDescription === 'DIW')}
				username={username}
				readOnly={readOnly}
			/>
		} else if (currentMenu === 'comment') {
			return <Comment 
				comments={picklistComments.sort((a, b) => a.sk.localeCompare(b.sk))} 
				onPost={onPostComment}
				onActive={onActiveComment}
				username={username}
			/>
		} else if (currentMenu === 'extra') {
			return <ExtraCompoent 
				orderNo={id}
				username={username}
				status={null} dateRange={null} keyword={id}
				readOnly={readOnly}
			/>
		} else if (currentMenu === 'retain_record') {
			return <RetainRecord disabledInput={readOnly} />
		}
	}
	
	const mainMenu = useMemo(() => id.startsWith('9') ? 
		MainMenu : MainMenu.filter(m => !['retain_record', 'reason_code'].includes(m.value))
	, [ id ])

	return order ? <div className="mx-5 mt-2">
		<ProductionOrderHeader id={id} productionOrder={order} title={Documents.PRODUCTION_PROCESS} picklist={picklistHeader}/>
		{currentTimeType === '' && <TabMenu
			menus={mainMenu}
			onChanged={(idx) => onTabSelected(mainMenu[idx].value)}
			selectedIndex={mainMenu.findIndex(m => m.value === currentMenu)}
			isEmptyReason={order.materialType === OrderType.BULK || reasonCodes.length === 0}
		/>}
		<PicklistContext.Provider value={{ 
			items: picklistItems, header: picklistHeader, comments: picklistComments, mutateHeader
			}}>
			<MovementContext.Provider value={{ movements, mutateMovements }}>
				<OrderReceiptContext.Provider value={{ orderReceipts, mutateOrderReceipt, mutateOrderReceipts }}>
					{renderBody()}
				</OrderReceiptContext.Provider>
			</MovementContext.Provider>
		</PicklistContext.Provider>
	</div> : <SpinnerLoading />
}

export default ProductionProcessComponent